module.exports = __webpack_public_path__ + "img/Tianjin-power.ed6ff2f9.png";